import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useApi from '../../api/useApi';
import Moment from 'react-moment';

const TraderDashboard = () => {
    const navigate = useNavigate();
    const [modalVisible, setModalVisible] = useState(false);
    const [auction, setAuction] = useState({});

    const api = useApi();

    const loadTraderDashboard = async () => {
        await api.getTraderDashboard().then((data) => {
            console.log(data)
            setAuction(data)
        })
    }

    useEffect(() => {
        loadTraderDashboard();
    }, []);


    const handleAuctionDetail = () => {
        if (auction?.auctionStatus > -1)
            navigate(`/liveAuction`);
        else
            alert("Action not allowed. No running auction.")
    }

    const handleCompletedLotReport = () => {
        if (auction?.auctionStatus != 0)
            navigate(`/completedLotsReport`);
        else
            alert("Action not allowed. No running auction.")
    }

    return (
        <div>
            <div className="inner-body">
                <div className="page-header">
                    <div>
                        <h2 className="main-content-title tx-24 mg-b-5">Auctions</h2>
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                <a className="custom-link">Home</a></li>
                        </ol>
                    </div>
                   
                </div>
                <div class="row row-sm">
                    <div class="col-xl-6">
                        <div class="card custom-card  bd-b-primary">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-lg-12">
                                        <div class="d-flex">
                                            <div class="settings-main-icon me-4 mt-1">
                                                <div class="avatar avatar-md bg-primary-transparent text-primary "><i class="ti-flag-alt-2 fs-18"></i></div>
                                            </div>
                                            <div>
                                                <h5 className="tx-14 d-flex tx-uppercase  custom-link" onClick={handleAuctionDetail}> Auction Details</h5>
                                                {auction?.auctionStatus > -1 ?
                                                    <p className="tx-13 text-muted mb-0"> <strong> {auction?.companyName}</strong>  <br></br> <span className="badge   bg-warning  me-1">{auction?.message} </span> |  <Moment format="DD-MMM-YYYY">{auction?.auctionDate}</Moment>{" "}  {auction?.startTime ? <span><Moment format="LT">{auction?.startTime}</Moment>{"  to  "}<Moment format="LT">{auction?.endTime}</Moment></span> : null} </p>
                                                    : <p className="tx-13 text-muted mb-0"> <span className="badge   bg-warning  me-1">{auction?.message} </span> <br></br> <i><small> Please contact your administrator.</small> </i> </p>
                                                }

                                                {/*{auction.auctionStatus === 0 ? <p className="tx-13 text-muted mb-0">Next auction scheduled at  <br></br> <Moment format="DD-MMM-YYYY">{auction?.auctionDate}</Moment> <Moment format="LT">{auction?.startTime}</Moment> </p> :*/}
                                                {/*    (auction?.auctionStatus === 1 ? <p className="tx-13 text-muted mb-0">Current auction : <strong> {auction?.companyName}</strong> <br></br> <Moment format="DD-MMM-YYYY">{auction?.auctionDate}</Moment>{"  "} <Moment format="LT">{auction?.startTime}</Moment>{"  to  "}<Moment format="LT">{auction?.endTime}</Moment> </p> :*/}
                                                {/*        <p className="tx-13 text-muted mb-0">No auctions scheduled. <br></br> Please contact your administrator </p>)}*/}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/*<div class="card-footer rounded-0">*/}
                            {/*    <a href="" class="tx-14 mb-0">Go to Settings</a>*/}
                            {/*    <label class="custom-switch float-end mb-0">*/}
                            {/*        <a href="" class="tx-14 mb-0 me-2 text-dark">Restore default</a> <input type="checkbox" name="custom-switch-checkbox" class="custom-switch-input" /> <span class="custom-switch-indicator"></span>*/}
                            {/*    </label>*/}
                            {/*</div>*/}
                        </div>
                    </div>
                    <div class="col-xl-6">
                        <div class="card custom-card  bd-b-primary">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-lg-12">
                                        <div class="d-flex" onClick={handleCompletedLotReport}>
                                            <div class="settings-main-icon me-4 mt-1">
                                                <div class="avatar avatar-md bg-primary-transparent text-primary"><i class="ti-layout-grid2 fs-18"></i></div>
                                            </div>
                                            <div>
                                                <h5 class="tx-14 d-flex  tx-uppercase custom-link" >Completed Lots Report</h5>
                                                <p className="tx-13 mb-0">View detail of sold and withdrawn lots of the current running auction</p>
                                                <i> <small className="text-muted">Available from the current auction only.</small></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/*<div class="card-footer rounded-0">*/}
                            {/*    <a href="" class="tx-14 mb-0">Go to Settings</a>*/}
                            {/*    <label class="custom-switch float-end mb-0">*/}
                            {/*        <a href="" class="tx-14 mb-0 me-2 text-dark">Restore default</a> <input type="checkbox" name="custom-switch-checkbox" class="custom-switch-input" checked="" />*/}
                            {/*        <span class="custom-switch-indicator"></span>*/}
                            {/*    </label>*/}
                            {/*</div>*/}
                        </div>
                    </div>


                </div>


            </div>

        </div>
    );
};

export default TraderDashboard;



